"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundReserveEvent = exports.AddReserveEvent = exports.RewardSchemeEvent = exports.RewardDebtEvent = exports.ClaimRewardEvent = exports.LiquidateCollateralWithStablecoinEvent = exports.LiquidateCollateralEvent = exports.ReturnStablecoinEvent = exports.MintStablecoinEvent = exports.UpdateStablecoinDebtInfoEvent = exports.UpdateDebtInfoEvent = exports.UnlockCollateralEvent = exports.LockCollateralEvent = exports.RepayAssetEvent = exports.BorrowAssetEvent = exports.WithdrawAssetEvent = exports.SupplyAssetEvent = exports.SetCdpPausedEvent = exports.SetStalePriceGracePeriodEvent = exports.SetSmallLiquidationSizeEvent = exports.SetMinimumCloseFactorEvent = exports.SetCompleteLiquidationThresholdEvent = exports.SetStablecoinMintCapEvent = exports.SetStablecoinInterestRateEvent = exports.SetLiquidationFeeEvent = exports.SetInterestFeeEvent = exports.UpdateAccountEModeCategoryNameEvent = exports.UpdateEModeCategoryEvent = exports.NewEModeCategoryEvent = exports.UpdateAssetParamsEvent = exports.NewAssetParamsEvent = exports.RemoveRateStrategyParamsEvent = exports.UpdateRateStrategyParamsEvent = exports.NewRateStrategyParamsEvent = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const rate_strategy_params_1 = require("./rate_strategy_params");
const asset_params_1 = require("./asset_params");
const e_mode_category_1 = require("./e_mode_category");
const duration_1 = require("../google/protobuf/duration");
const debt_info_1 = require("./debt_info");
const stablecoin_debt_info_1 = require("./stablecoin_debt_info");
const reward_scheme_1 = require("./reward_scheme");
exports.protobufPackage = "Switcheo.carbon.cdp";
const baseNewRateStrategyParamsEvent = { type: "" };
exports.NewRateStrategyParamsEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rateStrategyParams !== undefined) {
            rate_strategy_params_1.RateStrategyParams.encode(message.rateStrategyParams, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseNewRateStrategyParamsEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rateStrategyParams = rate_strategy_params_1.RateStrategyParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseNewRateStrategyParamsEvent);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromJSON(object.rateStrategyParams)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rateStrategyParams !== undefined &&
            (obj.rateStrategyParams = message.rateStrategyParams
                ? rate_strategy_params_1.RateStrategyParams.toJSON(message.rateStrategyParams)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseNewRateStrategyParamsEvent);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromPartial(object.rateStrategyParams)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseUpdateRateStrategyParamsEvent = { type: "" };
exports.UpdateRateStrategyParamsEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rateStrategyParams !== undefined) {
            rate_strategy_params_1.RateStrategyParams.encode(message.rateStrategyParams, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateRateStrategyParamsEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rateStrategyParams = rate_strategy_params_1.RateStrategyParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateRateStrategyParamsEvent);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromJSON(object.rateStrategyParams)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rateStrategyParams !== undefined &&
            (obj.rateStrategyParams = message.rateStrategyParams
                ? rate_strategy_params_1.RateStrategyParams.toJSON(message.rateStrategyParams)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseUpdateRateStrategyParamsEvent);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromPartial(object.rateStrategyParams)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseRemoveRateStrategyParamsEvent = { type: "" };
exports.RemoveRateStrategyParamsEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rateStrategyParams !== undefined) {
            rate_strategy_params_1.RateStrategyParams.encode(message.rateStrategyParams, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRemoveRateStrategyParamsEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rateStrategyParams = rate_strategy_params_1.RateStrategyParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRemoveRateStrategyParamsEvent);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromJSON(object.rateStrategyParams)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rateStrategyParams !== undefined &&
            (obj.rateStrategyParams = message.rateStrategyParams
                ? rate_strategy_params_1.RateStrategyParams.toJSON(message.rateStrategyParams)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRemoveRateStrategyParamsEvent);
        message.rateStrategyParams =
            object.rateStrategyParams !== undefined &&
                object.rateStrategyParams !== null
                ? rate_strategy_params_1.RateStrategyParams.fromPartial(object.rateStrategyParams)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseNewAssetParamsEvent = { type: "" };
exports.NewAssetParamsEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.assetParams !== undefined) {
            asset_params_1.AssetParams.encode(message.assetParams, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseNewAssetParamsEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.assetParams = asset_params_1.AssetParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseNewAssetParamsEvent);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromJSON(object.assetParams)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.assetParams !== undefined &&
            (obj.assetParams = message.assetParams
                ? asset_params_1.AssetParams.toJSON(message.assetParams)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseNewAssetParamsEvent);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromPartial(object.assetParams)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseUpdateAssetParamsEvent = { type: "" };
exports.UpdateAssetParamsEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.assetParams !== undefined) {
            asset_params_1.AssetParams.encode(message.assetParams, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateAssetParamsEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.assetParams = asset_params_1.AssetParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateAssetParamsEvent);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromJSON(object.assetParams)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.assetParams !== undefined &&
            (obj.assetParams = message.assetParams
                ? asset_params_1.AssetParams.toJSON(message.assetParams)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseUpdateAssetParamsEvent);
        message.assetParams =
            object.assetParams !== undefined && object.assetParams !== null
                ? asset_params_1.AssetParams.fromPartial(object.assetParams)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseNewEModeCategoryEvent = { type: "" };
exports.NewEModeCategoryEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.eModeCategory !== undefined) {
            e_mode_category_1.EModeCategory.encode(message.eModeCategory, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseNewEModeCategoryEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eModeCategory = e_mode_category_1.EModeCategory.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseNewEModeCategoryEvent);
        message.eModeCategory =
            object.eModeCategory !== undefined && object.eModeCategory !== null
                ? e_mode_category_1.EModeCategory.fromJSON(object.eModeCategory)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.eModeCategory !== undefined &&
            (obj.eModeCategory = message.eModeCategory
                ? e_mode_category_1.EModeCategory.toJSON(message.eModeCategory)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseNewEModeCategoryEvent);
        message.eModeCategory =
            object.eModeCategory !== undefined && object.eModeCategory !== null
                ? e_mode_category_1.EModeCategory.fromPartial(object.eModeCategory)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseUpdateEModeCategoryEvent = { type: "" };
exports.UpdateEModeCategoryEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.eModeCategory !== undefined) {
            e_mode_category_1.EModeCategory.encode(message.eModeCategory, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateEModeCategoryEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.eModeCategory = e_mode_category_1.EModeCategory.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateEModeCategoryEvent);
        message.eModeCategory =
            object.eModeCategory !== undefined && object.eModeCategory !== null
                ? e_mode_category_1.EModeCategory.fromJSON(object.eModeCategory)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.eModeCategory !== undefined &&
            (obj.eModeCategory = message.eModeCategory
                ? e_mode_category_1.EModeCategory.toJSON(message.eModeCategory)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseUpdateEModeCategoryEvent);
        message.eModeCategory =
            object.eModeCategory !== undefined && object.eModeCategory !== null
                ? e_mode_category_1.EModeCategory.fromPartial(object.eModeCategory)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseUpdateAccountEModeCategoryNameEvent = {
    account: "",
    eModeCategoryName: "",
};
exports.UpdateAccountEModeCategoryNameEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.account !== "") {
            writer.uint32(10).string(message.account);
        }
        if (message.eModeCategoryName !== "") {
            writer.uint32(18).string(message.eModeCategoryName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateAccountEModeCategoryNameEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.account = reader.string();
                    break;
                case 2:
                    message.eModeCategoryName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateAccountEModeCategoryNameEvent);
        message.account =
            object.account !== undefined && object.account !== null
                ? String(object.account)
                : "";
        message.eModeCategoryName =
            object.eModeCategoryName !== undefined &&
                object.eModeCategoryName !== null
                ? String(object.eModeCategoryName)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.account !== undefined && (obj.account = message.account);
        message.eModeCategoryName !== undefined &&
            (obj.eModeCategoryName = message.eModeCategoryName);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseUpdateAccountEModeCategoryNameEvent);
        message.account = (_a = object.account) !== null && _a !== void 0 ? _a : "";
        message.eModeCategoryName = (_b = object.eModeCategoryName) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseSetInterestFeeEvent = { interestFee: "", type: "" };
exports.SetInterestFeeEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.interestFee !== "") {
            writer.uint32(10).string(message.interestFee);
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetInterestFeeEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.interestFee = reader.string();
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetInterestFeeEvent);
        message.interestFee =
            object.interestFee !== undefined && object.interestFee !== null
                ? String(object.interestFee)
                : "";
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.interestFee !== undefined &&
            (obj.interestFee = message.interestFee);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseSetInterestFeeEvent);
        message.interestFee = (_a = object.interestFee) !== null && _a !== void 0 ? _a : "";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseSetLiquidationFeeEvent = { liquidationFee: "", type: "" };
exports.SetLiquidationFeeEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.liquidationFee !== "") {
            writer.uint32(10).string(message.liquidationFee);
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetLiquidationFeeEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.liquidationFee = reader.string();
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetLiquidationFeeEvent);
        message.liquidationFee =
            object.liquidationFee !== undefined && object.liquidationFee !== null
                ? String(object.liquidationFee)
                : "";
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.liquidationFee !== undefined &&
            (obj.liquidationFee = message.liquidationFee);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseSetLiquidationFeeEvent);
        message.liquidationFee = (_a = object.liquidationFee) !== null && _a !== void 0 ? _a : "";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseSetStablecoinInterestRateEvent = {
    stablecoinInterestRate: "",
    type: "",
    stablecoinInterestRateDec: "",
};
exports.SetStablecoinInterestRateEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.stablecoinInterestRate !== "") {
            writer.uint32(10).string(message.stablecoinInterestRate);
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        if (message.stablecoinInterestRateDec !== "") {
            writer.uint32(26).string(message.stablecoinInterestRateDec);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetStablecoinInterestRateEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stablecoinInterestRate = reader.string();
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                case 3:
                    message.stablecoinInterestRateDec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetStablecoinInterestRateEvent);
        message.stablecoinInterestRate =
            object.stablecoinInterestRate !== undefined &&
                object.stablecoinInterestRate !== null
                ? String(object.stablecoinInterestRate)
                : "";
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        message.stablecoinInterestRateDec =
            object.stablecoinInterestRateDec !== undefined &&
                object.stablecoinInterestRateDec !== null
                ? String(object.stablecoinInterestRateDec)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.stablecoinInterestRate !== undefined &&
            (obj.stablecoinInterestRate = message.stablecoinInterestRate);
        message.type !== undefined && (obj.type = message.type);
        message.stablecoinInterestRateDec !== undefined &&
            (obj.stablecoinInterestRateDec = message.stablecoinInterestRateDec);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseSetStablecoinInterestRateEvent);
        message.stablecoinInterestRate = (_a = object.stablecoinInterestRate) !== null && _a !== void 0 ? _a : "";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        message.stablecoinInterestRateDec = (_c = object.stablecoinInterestRateDec) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseSetStablecoinMintCapEvent = {
    stablecoinMintCap: "",
    type: "",
};
exports.SetStablecoinMintCapEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.stablecoinMintCap !== "") {
            writer.uint32(10).string(message.stablecoinMintCap);
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetStablecoinMintCapEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stablecoinMintCap = reader.string();
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetStablecoinMintCapEvent);
        message.stablecoinMintCap =
            object.stablecoinMintCap !== undefined &&
                object.stablecoinMintCap !== null
                ? String(object.stablecoinMintCap)
                : "";
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.stablecoinMintCap !== undefined &&
            (obj.stablecoinMintCap = message.stablecoinMintCap);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseSetStablecoinMintCapEvent);
        message.stablecoinMintCap = (_a = object.stablecoinMintCap) !== null && _a !== void 0 ? _a : "";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseSetCompleteLiquidationThresholdEvent = {
    completeLiquidationThreshold: "",
    type: "",
};
exports.SetCompleteLiquidationThresholdEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.completeLiquidationThreshold !== "") {
            writer.uint32(10).string(message.completeLiquidationThreshold);
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetCompleteLiquidationThresholdEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.completeLiquidationThreshold = reader.string();
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetCompleteLiquidationThresholdEvent);
        message.completeLiquidationThreshold =
            object.completeLiquidationThreshold !== undefined &&
                object.completeLiquidationThreshold !== null
                ? String(object.completeLiquidationThreshold)
                : "";
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.completeLiquidationThreshold !== undefined &&
            (obj.completeLiquidationThreshold = message.completeLiquidationThreshold);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseSetCompleteLiquidationThresholdEvent);
        message.completeLiquidationThreshold =
            (_a = object.completeLiquidationThreshold) !== null && _a !== void 0 ? _a : "";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseSetMinimumCloseFactorEvent = {
    minimumCloseFactor: "",
    type: "",
};
exports.SetMinimumCloseFactorEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.minimumCloseFactor !== "") {
            writer.uint32(10).string(message.minimumCloseFactor);
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetMinimumCloseFactorEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.minimumCloseFactor = reader.string();
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetMinimumCloseFactorEvent);
        message.minimumCloseFactor =
            object.minimumCloseFactor !== undefined &&
                object.minimumCloseFactor !== null
                ? String(object.minimumCloseFactor)
                : "";
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.minimumCloseFactor !== undefined &&
            (obj.minimumCloseFactor = message.minimumCloseFactor);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseSetMinimumCloseFactorEvent);
        message.minimumCloseFactor = (_a = object.minimumCloseFactor) !== null && _a !== void 0 ? _a : "";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseSetSmallLiquidationSizeEvent = {
    smallLiquidationSize: "",
    type: "",
};
exports.SetSmallLiquidationSizeEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.smallLiquidationSize !== "") {
            writer.uint32(10).string(message.smallLiquidationSize);
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetSmallLiquidationSizeEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.smallLiquidationSize = reader.string();
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetSmallLiquidationSizeEvent);
        message.smallLiquidationSize =
            object.smallLiquidationSize !== undefined &&
                object.smallLiquidationSize !== null
                ? String(object.smallLiquidationSize)
                : "";
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.smallLiquidationSize !== undefined &&
            (obj.smallLiquidationSize = message.smallLiquidationSize);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseSetSmallLiquidationSizeEvent);
        message.smallLiquidationSize = (_a = object.smallLiquidationSize) !== null && _a !== void 0 ? _a : "";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseSetStalePriceGracePeriodEvent = { type: "" };
exports.SetStalePriceGracePeriodEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.stalePriceGracePeriod !== undefined) {
            duration_1.Duration.encode(message.stalePriceGracePeriod, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetStalePriceGracePeriodEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stalePriceGracePeriod = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetStalePriceGracePeriodEvent);
        message.stalePriceGracePeriod =
            object.stalePriceGracePeriod !== undefined &&
                object.stalePriceGracePeriod !== null
                ? duration_1.Duration.fromJSON(object.stalePriceGracePeriod)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.stalePriceGracePeriod !== undefined &&
            (obj.stalePriceGracePeriod = message.stalePriceGracePeriod
                ? duration_1.Duration.toJSON(message.stalePriceGracePeriod)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseSetStalePriceGracePeriodEvent);
        message.stalePriceGracePeriod =
            object.stalePriceGracePeriod !== undefined &&
                object.stalePriceGracePeriod !== null
                ? duration_1.Duration.fromPartial(object.stalePriceGracePeriod)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseSetCdpPausedEvent = { cdpPaused: false, type: "" };
exports.SetCdpPausedEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.cdpPaused === true) {
            writer.uint32(8).bool(message.cdpPaused);
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetCdpPausedEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cdpPaused = reader.bool();
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetCdpPausedEvent);
        message.cdpPaused =
            object.cdpPaused !== undefined && object.cdpPaused !== null
                ? Boolean(object.cdpPaused)
                : false;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.cdpPaused !== undefined && (obj.cdpPaused = message.cdpPaused);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseSetCdpPausedEvent);
        message.cdpPaused = (_a = object.cdpPaused) !== null && _a !== void 0 ? _a : false;
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseSupplyAssetEvent = {
    supplier: "",
    denom: "",
    amountSupplied: "",
    cdpDenom: "",
    amountMinted: "",
};
exports.SupplyAssetEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.supplier !== "") {
            writer.uint32(10).string(message.supplier);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amountSupplied !== "") {
            writer.uint32(26).string(message.amountSupplied);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(34).string(message.cdpDenom);
        }
        if (message.amountMinted !== "") {
            writer.uint32(42).string(message.amountMinted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSupplyAssetEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.supplier = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amountSupplied = reader.string();
                    break;
                case 4:
                    message.cdpDenom = reader.string();
                    break;
                case 5:
                    message.amountMinted = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSupplyAssetEvent);
        message.supplier =
            object.supplier !== undefined && object.supplier !== null
                ? String(object.supplier)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amountSupplied =
            object.amountSupplied !== undefined && object.amountSupplied !== null
                ? String(object.amountSupplied)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.amountMinted =
            object.amountMinted !== undefined && object.amountMinted !== null
                ? String(object.amountMinted)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.supplier !== undefined && (obj.supplier = message.supplier);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amountSupplied !== undefined &&
            (obj.amountSupplied = message.amountSupplied);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.amountMinted !== undefined &&
            (obj.amountMinted = message.amountMinted);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseSupplyAssetEvent);
        message.supplier = (_a = object.supplier) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amountSupplied = (_c = object.amountSupplied) !== null && _c !== void 0 ? _c : "";
        message.cdpDenom = (_d = object.cdpDenom) !== null && _d !== void 0 ? _d : "";
        message.amountMinted = (_e = object.amountMinted) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseWithdrawAssetEvent = {
    withdrawer: "",
    denom: "",
    amountWithdrawed: "",
    cdpDenom: "",
    amountBurned: "",
};
exports.WithdrawAssetEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.withdrawer !== "") {
            writer.uint32(10).string(message.withdrawer);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amountWithdrawed !== "") {
            writer.uint32(26).string(message.amountWithdrawed);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(34).string(message.cdpDenom);
        }
        if (message.amountBurned !== "") {
            writer.uint32(42).string(message.amountBurned);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseWithdrawAssetEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.withdrawer = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amountWithdrawed = reader.string();
                    break;
                case 4:
                    message.cdpDenom = reader.string();
                    break;
                case 5:
                    message.amountBurned = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseWithdrawAssetEvent);
        message.withdrawer =
            object.withdrawer !== undefined && object.withdrawer !== null
                ? String(object.withdrawer)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amountWithdrawed =
            object.amountWithdrawed !== undefined && object.amountWithdrawed !== null
                ? String(object.amountWithdrawed)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.amountBurned =
            object.amountBurned !== undefined && object.amountBurned !== null
                ? String(object.amountBurned)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.withdrawer !== undefined && (obj.withdrawer = message.withdrawer);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amountWithdrawed !== undefined &&
            (obj.amountWithdrawed = message.amountWithdrawed);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.amountBurned !== undefined &&
            (obj.amountBurned = message.amountBurned);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseWithdrawAssetEvent);
        message.withdrawer = (_a = object.withdrawer) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amountWithdrawed = (_c = object.amountWithdrawed) !== null && _c !== void 0 ? _c : "";
        message.cdpDenom = (_d = object.cdpDenom) !== null && _d !== void 0 ? _d : "";
        message.amountBurned = (_e = object.amountBurned) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseBorrowAssetEvent = {
    borrower: "",
    denom: "",
    amountBorrowed: "",
    debtValue: "",
    collateralValue: "",
    initialCumulativeInterestMultiplier: "",
};
exports.BorrowAssetEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.borrower !== "") {
            writer.uint32(10).string(message.borrower);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amountBorrowed !== "") {
            writer.uint32(26).string(message.amountBorrowed);
        }
        if (message.debtValue !== "") {
            writer.uint32(34).string(message.debtValue);
        }
        if (message.collateralValue !== "") {
            writer.uint32(50).string(message.collateralValue);
        }
        if (message.initialCumulativeInterestMultiplier !== "") {
            writer.uint32(42).string(message.initialCumulativeInterestMultiplier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseBorrowAssetEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.borrower = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amountBorrowed = reader.string();
                    break;
                case 4:
                    message.debtValue = reader.string();
                    break;
                case 6:
                    message.collateralValue = reader.string();
                    break;
                case 5:
                    message.initialCumulativeInterestMultiplier = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseBorrowAssetEvent);
        message.borrower =
            object.borrower !== undefined && object.borrower !== null
                ? String(object.borrower)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amountBorrowed =
            object.amountBorrowed !== undefined && object.amountBorrowed !== null
                ? String(object.amountBorrowed)
                : "";
        message.debtValue =
            object.debtValue !== undefined && object.debtValue !== null
                ? String(object.debtValue)
                : "";
        message.collateralValue =
            object.collateralValue !== undefined && object.collateralValue !== null
                ? String(object.collateralValue)
                : "";
        message.initialCumulativeInterestMultiplier =
            object.initialCumulativeInterestMultiplier !== undefined &&
                object.initialCumulativeInterestMultiplier !== null
                ? String(object.initialCumulativeInterestMultiplier)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.borrower !== undefined && (obj.borrower = message.borrower);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amountBorrowed !== undefined &&
            (obj.amountBorrowed = message.amountBorrowed);
        message.debtValue !== undefined && (obj.debtValue = message.debtValue);
        message.collateralValue !== undefined &&
            (obj.collateralValue = message.collateralValue);
        message.initialCumulativeInterestMultiplier !== undefined &&
            (obj.initialCumulativeInterestMultiplier =
                message.initialCumulativeInterestMultiplier);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, baseBorrowAssetEvent);
        message.borrower = (_a = object.borrower) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amountBorrowed = (_c = object.amountBorrowed) !== null && _c !== void 0 ? _c : "";
        message.debtValue = (_d = object.debtValue) !== null && _d !== void 0 ? _d : "";
        message.collateralValue = (_e = object.collateralValue) !== null && _e !== void 0 ? _e : "";
        message.initialCumulativeInterestMultiplier =
            (_f = object.initialCumulativeInterestMultiplier) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
const baseRepayAssetEvent = {
    repayer: "",
    debtor: "",
    denom: "",
    principalRepaid: "",
    interestRepaid: "",
    debtValue: "",
    collateralValue: "",
};
exports.RepayAssetEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.repayer !== "") {
            writer.uint32(10).string(message.repayer);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.principalRepaid !== "") {
            writer.uint32(34).string(message.principalRepaid);
        }
        if (message.interestRepaid !== "") {
            writer.uint32(42).string(message.interestRepaid);
        }
        if (message.debtValue !== "") {
            writer.uint32(50).string(message.debtValue);
        }
        if (message.collateralValue !== "") {
            writer.uint32(58).string(message.collateralValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRepayAssetEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.repayer = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.principalRepaid = reader.string();
                    break;
                case 5:
                    message.interestRepaid = reader.string();
                    break;
                case 6:
                    message.debtValue = reader.string();
                    break;
                case 7:
                    message.collateralValue = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRepayAssetEvent);
        message.repayer =
            object.repayer !== undefined && object.repayer !== null
                ? String(object.repayer)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.principalRepaid =
            object.principalRepaid !== undefined && object.principalRepaid !== null
                ? String(object.principalRepaid)
                : "";
        message.interestRepaid =
            object.interestRepaid !== undefined && object.interestRepaid !== null
                ? String(object.interestRepaid)
                : "";
        message.debtValue =
            object.debtValue !== undefined && object.debtValue !== null
                ? String(object.debtValue)
                : "";
        message.collateralValue =
            object.collateralValue !== undefined && object.collateralValue !== null
                ? String(object.collateralValue)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.repayer !== undefined && (obj.repayer = message.repayer);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.denom !== undefined && (obj.denom = message.denom);
        message.principalRepaid !== undefined &&
            (obj.principalRepaid = message.principalRepaid);
        message.interestRepaid !== undefined &&
            (obj.interestRepaid = message.interestRepaid);
        message.debtValue !== undefined && (obj.debtValue = message.debtValue);
        message.collateralValue !== undefined &&
            (obj.collateralValue = message.collateralValue);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseRepayAssetEvent);
        message.repayer = (_a = object.repayer) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.principalRepaid = (_d = object.principalRepaid) !== null && _d !== void 0 ? _d : "";
        message.interestRepaid = (_e = object.interestRepaid) !== null && _e !== void 0 ? _e : "";
        message.debtValue = (_f = object.debtValue) !== null && _f !== void 0 ? _f : "";
        message.collateralValue = (_g = object.collateralValue) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};
const baseLockCollateralEvent = {
    locker: "",
    cdpDenom: "",
    amountLocked: "",
    debtValue: "",
    collateralValue: "",
};
exports.LockCollateralEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.locker !== "") {
            writer.uint32(10).string(message.locker);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(18).string(message.cdpDenom);
        }
        if (message.amountLocked !== "") {
            writer.uint32(26).string(message.amountLocked);
        }
        if (message.debtValue !== "") {
            writer.uint32(34).string(message.debtValue);
        }
        if (message.collateralValue !== "") {
            writer.uint32(42).string(message.collateralValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseLockCollateralEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.locker = reader.string();
                    break;
                case 2:
                    message.cdpDenom = reader.string();
                    break;
                case 3:
                    message.amountLocked = reader.string();
                    break;
                case 4:
                    message.debtValue = reader.string();
                    break;
                case 5:
                    message.collateralValue = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseLockCollateralEvent);
        message.locker =
            object.locker !== undefined && object.locker !== null
                ? String(object.locker)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.amountLocked =
            object.amountLocked !== undefined && object.amountLocked !== null
                ? String(object.amountLocked)
                : "";
        message.debtValue =
            object.debtValue !== undefined && object.debtValue !== null
                ? String(object.debtValue)
                : "";
        message.collateralValue =
            object.collateralValue !== undefined && object.collateralValue !== null
                ? String(object.collateralValue)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.locker !== undefined && (obj.locker = message.locker);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.amountLocked !== undefined &&
            (obj.amountLocked = message.amountLocked);
        message.debtValue !== undefined && (obj.debtValue = message.debtValue);
        message.collateralValue !== undefined &&
            (obj.collateralValue = message.collateralValue);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseLockCollateralEvent);
        message.locker = (_a = object.locker) !== null && _a !== void 0 ? _a : "";
        message.cdpDenom = (_b = object.cdpDenom) !== null && _b !== void 0 ? _b : "";
        message.amountLocked = (_c = object.amountLocked) !== null && _c !== void 0 ? _c : "";
        message.debtValue = (_d = object.debtValue) !== null && _d !== void 0 ? _d : "";
        message.collateralValue = (_e = object.collateralValue) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseUnlockCollateralEvent = {
    unlocker: "",
    cdpDenom: "",
    amountUnlocked: "",
    debtValue: "",
    collateralValue: "",
};
exports.UnlockCollateralEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.unlocker !== "") {
            writer.uint32(10).string(message.unlocker);
        }
        if (message.cdpDenom !== "") {
            writer.uint32(18).string(message.cdpDenom);
        }
        if (message.amountUnlocked !== "") {
            writer.uint32(26).string(message.amountUnlocked);
        }
        if (message.debtValue !== "") {
            writer.uint32(34).string(message.debtValue);
        }
        if (message.collateralValue !== "") {
            writer.uint32(42).string(message.collateralValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUnlockCollateralEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unlocker = reader.string();
                    break;
                case 2:
                    message.cdpDenom = reader.string();
                    break;
                case 3:
                    message.amountUnlocked = reader.string();
                    break;
                case 4:
                    message.debtValue = reader.string();
                    break;
                case 5:
                    message.collateralValue = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUnlockCollateralEvent);
        message.unlocker =
            object.unlocker !== undefined && object.unlocker !== null
                ? String(object.unlocker)
                : "";
        message.cdpDenom =
            object.cdpDenom !== undefined && object.cdpDenom !== null
                ? String(object.cdpDenom)
                : "";
        message.amountUnlocked =
            object.amountUnlocked !== undefined && object.amountUnlocked !== null
                ? String(object.amountUnlocked)
                : "";
        message.debtValue =
            object.debtValue !== undefined && object.debtValue !== null
                ? String(object.debtValue)
                : "";
        message.collateralValue =
            object.collateralValue !== undefined && object.collateralValue !== null
                ? String(object.collateralValue)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.unlocker !== undefined && (obj.unlocker = message.unlocker);
        message.cdpDenom !== undefined && (obj.cdpDenom = message.cdpDenom);
        message.amountUnlocked !== undefined &&
            (obj.amountUnlocked = message.amountUnlocked);
        message.debtValue !== undefined && (obj.debtValue = message.debtValue);
        message.collateralValue !== undefined &&
            (obj.collateralValue = message.collateralValue);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseUnlockCollateralEvent);
        message.unlocker = (_a = object.unlocker) !== null && _a !== void 0 ? _a : "";
        message.cdpDenom = (_b = object.cdpDenom) !== null && _b !== void 0 ? _b : "";
        message.amountUnlocked = (_c = object.amountUnlocked) !== null && _c !== void 0 ? _c : "";
        message.debtValue = (_d = object.debtValue) !== null && _d !== void 0 ? _d : "";
        message.collateralValue = (_e = object.collateralValue) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseUpdateDebtInfoEvent = { type: "" };
exports.UpdateDebtInfoEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.debtInfo !== undefined) {
            debt_info_1.DebtInfo.encode(message.debtInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateDebtInfoEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.debtInfo = debt_info_1.DebtInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateDebtInfoEvent);
        message.debtInfo =
            object.debtInfo !== undefined && object.debtInfo !== null
                ? debt_info_1.DebtInfo.fromJSON(object.debtInfo)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.debtInfo !== undefined &&
            (obj.debtInfo = message.debtInfo
                ? debt_info_1.DebtInfo.toJSON(message.debtInfo)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseUpdateDebtInfoEvent);
        message.debtInfo =
            object.debtInfo !== undefined && object.debtInfo !== null
                ? debt_info_1.DebtInfo.fromPartial(object.debtInfo)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseUpdateStablecoinDebtInfoEvent = { type: "" };
exports.UpdateStablecoinDebtInfoEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.stablecoinDebtInfo !== undefined) {
            stablecoin_debt_info_1.StablecoinDebtInfo.encode(message.stablecoinDebtInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateStablecoinDebtInfoEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stablecoinDebtInfo = stablecoin_debt_info_1.StablecoinDebtInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateStablecoinDebtInfoEvent);
        message.stablecoinDebtInfo =
            object.stablecoinDebtInfo !== undefined &&
                object.stablecoinDebtInfo !== null
                ? stablecoin_debt_info_1.StablecoinDebtInfo.fromJSON(object.stablecoinDebtInfo)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.stablecoinDebtInfo !== undefined &&
            (obj.stablecoinDebtInfo = message.stablecoinDebtInfo
                ? stablecoin_debt_info_1.StablecoinDebtInfo.toJSON(message.stablecoinDebtInfo)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseUpdateStablecoinDebtInfoEvent);
        message.stablecoinDebtInfo =
            object.stablecoinDebtInfo !== undefined &&
                object.stablecoinDebtInfo !== null
                ? stablecoin_debt_info_1.StablecoinDebtInfo.fromPartial(object.stablecoinDebtInfo)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseMintStablecoinEvent = {
    minter: "",
    denom: "",
    amountMinted: "",
    debtValue: "",
    collateralValue: "",
    initialCumulativeInterestMultiplier: "",
};
exports.MintStablecoinEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.minter !== "") {
            writer.uint32(10).string(message.minter);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amountMinted !== "") {
            writer.uint32(26).string(message.amountMinted);
        }
        if (message.debtValue !== "") {
            writer.uint32(34).string(message.debtValue);
        }
        if (message.collateralValue !== "") {
            writer.uint32(50).string(message.collateralValue);
        }
        if (message.initialCumulativeInterestMultiplier !== "") {
            writer.uint32(42).string(message.initialCumulativeInterestMultiplier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMintStablecoinEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.minter = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amountMinted = reader.string();
                    break;
                case 4:
                    message.debtValue = reader.string();
                    break;
                case 6:
                    message.collateralValue = reader.string();
                    break;
                case 5:
                    message.initialCumulativeInterestMultiplier = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMintStablecoinEvent);
        message.minter =
            object.minter !== undefined && object.minter !== null
                ? String(object.minter)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amountMinted =
            object.amountMinted !== undefined && object.amountMinted !== null
                ? String(object.amountMinted)
                : "";
        message.debtValue =
            object.debtValue !== undefined && object.debtValue !== null
                ? String(object.debtValue)
                : "";
        message.collateralValue =
            object.collateralValue !== undefined && object.collateralValue !== null
                ? String(object.collateralValue)
                : "";
        message.initialCumulativeInterestMultiplier =
            object.initialCumulativeInterestMultiplier !== undefined &&
                object.initialCumulativeInterestMultiplier !== null
                ? String(object.initialCumulativeInterestMultiplier)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.minter !== undefined && (obj.minter = message.minter);
        message.denom !== undefined && (obj.denom = message.denom);
        message.amountMinted !== undefined &&
            (obj.amountMinted = message.amountMinted);
        message.debtValue !== undefined && (obj.debtValue = message.debtValue);
        message.collateralValue !== undefined &&
            (obj.collateralValue = message.collateralValue);
        message.initialCumulativeInterestMultiplier !== undefined &&
            (obj.initialCumulativeInterestMultiplier =
                message.initialCumulativeInterestMultiplier);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, baseMintStablecoinEvent);
        message.minter = (_a = object.minter) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.amountMinted = (_c = object.amountMinted) !== null && _c !== void 0 ? _c : "";
        message.debtValue = (_d = object.debtValue) !== null && _d !== void 0 ? _d : "";
        message.collateralValue = (_e = object.collateralValue) !== null && _e !== void 0 ? _e : "";
        message.initialCumulativeInterestMultiplier =
            (_f = object.initialCumulativeInterestMultiplier) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
const baseReturnStablecoinEvent = {
    returner: "",
    debtor: "",
    interestDenom: "",
    interestRepaid: "",
    principalRepaid: "",
    debtValue: "",
    collateralValue: "",
};
exports.ReturnStablecoinEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.returner !== "") {
            writer.uint32(10).string(message.returner);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.interestDenom !== "") {
            writer.uint32(26).string(message.interestDenom);
        }
        if (message.interestRepaid !== "") {
            writer.uint32(34).string(message.interestRepaid);
        }
        if (message.principalRepaid !== "") {
            writer.uint32(42).string(message.principalRepaid);
        }
        if (message.debtValue !== "") {
            writer.uint32(50).string(message.debtValue);
        }
        if (message.collateralValue !== "") {
            writer.uint32(58).string(message.collateralValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseReturnStablecoinEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.returner = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.interestDenom = reader.string();
                    break;
                case 4:
                    message.interestRepaid = reader.string();
                    break;
                case 5:
                    message.principalRepaid = reader.string();
                    break;
                case 6:
                    message.debtValue = reader.string();
                    break;
                case 7:
                    message.collateralValue = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseReturnStablecoinEvent);
        message.returner =
            object.returner !== undefined && object.returner !== null
                ? String(object.returner)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.interestDenom =
            object.interestDenom !== undefined && object.interestDenom !== null
                ? String(object.interestDenom)
                : "";
        message.interestRepaid =
            object.interestRepaid !== undefined && object.interestRepaid !== null
                ? String(object.interestRepaid)
                : "";
        message.principalRepaid =
            object.principalRepaid !== undefined && object.principalRepaid !== null
                ? String(object.principalRepaid)
                : "";
        message.debtValue =
            object.debtValue !== undefined && object.debtValue !== null
                ? String(object.debtValue)
                : "";
        message.collateralValue =
            object.collateralValue !== undefined && object.collateralValue !== null
                ? String(object.collateralValue)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.returner !== undefined && (obj.returner = message.returner);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.interestDenom !== undefined &&
            (obj.interestDenom = message.interestDenom);
        message.interestRepaid !== undefined &&
            (obj.interestRepaid = message.interestRepaid);
        message.principalRepaid !== undefined &&
            (obj.principalRepaid = message.principalRepaid);
        message.debtValue !== undefined && (obj.debtValue = message.debtValue);
        message.collateralValue !== undefined &&
            (obj.collateralValue = message.collateralValue);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseReturnStablecoinEvent);
        message.returner = (_a = object.returner) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.interestDenom = (_c = object.interestDenom) !== null && _c !== void 0 ? _c : "";
        message.interestRepaid = (_d = object.interestRepaid) !== null && _d !== void 0 ? _d : "";
        message.principalRepaid = (_e = object.principalRepaid) !== null && _e !== void 0 ? _e : "";
        message.debtValue = (_f = object.debtValue) !== null && _f !== void 0 ? _f : "";
        message.collateralValue = (_g = object.collateralValue) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};
const baseLiquidateCollateralEvent = {
    liquidator: "",
    debtor: "",
    collateralDenom: "",
    collateralAmountLiquidated: "",
    collateralAmountLiquidator: "",
    collateralAmountFee: "",
    liquidationPrice: "",
    marketPrice: "",
    discount: "",
    debtDenom: "",
    debtAmount: "",
    id: long_1.default.UZERO,
};
exports.LiquidateCollateralEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.liquidator !== "") {
            writer.uint32(10).string(message.liquidator);
        }
        if (message.debtor !== "") {
            writer.uint32(18).string(message.debtor);
        }
        if (message.collateralDenom !== "") {
            writer.uint32(26).string(message.collateralDenom);
        }
        if (message.collateralAmountLiquidated !== "") {
            writer.uint32(34).string(message.collateralAmountLiquidated);
        }
        if (message.collateralAmountLiquidator !== "") {
            writer.uint32(42).string(message.collateralAmountLiquidator);
        }
        if (message.collateralAmountFee !== "") {
            writer.uint32(50).string(message.collateralAmountFee);
        }
        if (message.liquidationPrice !== "") {
            writer.uint32(58).string(message.liquidationPrice);
        }
        if (message.marketPrice !== "") {
            writer.uint32(66).string(message.marketPrice);
        }
        if (message.discount !== "") {
            writer.uint32(74).string(message.discount);
        }
        if (message.debtDenom !== "") {
            writer.uint32(82).string(message.debtDenom);
        }
        if (message.debtAmount !== "") {
            writer.uint32(90).string(message.debtAmount);
        }
        if (!message.id.isZero()) {
            writer.uint32(96).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseLiquidateCollateralEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.liquidator = reader.string();
                    break;
                case 2:
                    message.debtor = reader.string();
                    break;
                case 3:
                    message.collateralDenom = reader.string();
                    break;
                case 4:
                    message.collateralAmountLiquidated = reader.string();
                    break;
                case 5:
                    message.collateralAmountLiquidator = reader.string();
                    break;
                case 6:
                    message.collateralAmountFee = reader.string();
                    break;
                case 7:
                    message.liquidationPrice = reader.string();
                    break;
                case 8:
                    message.marketPrice = reader.string();
                    break;
                case 9:
                    message.discount = reader.string();
                    break;
                case 10:
                    message.debtDenom = reader.string();
                    break;
                case 11:
                    message.debtAmount = reader.string();
                    break;
                case 12:
                    message.id = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseLiquidateCollateralEvent);
        message.liquidator =
            object.liquidator !== undefined && object.liquidator !== null
                ? String(object.liquidator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.collateralDenom =
            object.collateralDenom !== undefined && object.collateralDenom !== null
                ? String(object.collateralDenom)
                : "";
        message.collateralAmountLiquidated =
            object.collateralAmountLiquidated !== undefined &&
                object.collateralAmountLiquidated !== null
                ? String(object.collateralAmountLiquidated)
                : "";
        message.collateralAmountLiquidator =
            object.collateralAmountLiquidator !== undefined &&
                object.collateralAmountLiquidator !== null
                ? String(object.collateralAmountLiquidator)
                : "";
        message.collateralAmountFee =
            object.collateralAmountFee !== undefined &&
                object.collateralAmountFee !== null
                ? String(object.collateralAmountFee)
                : "";
        message.liquidationPrice =
            object.liquidationPrice !== undefined && object.liquidationPrice !== null
                ? String(object.liquidationPrice)
                : "";
        message.marketPrice =
            object.marketPrice !== undefined && object.marketPrice !== null
                ? String(object.marketPrice)
                : "";
        message.discount =
            object.discount !== undefined && object.discount !== null
                ? String(object.discount)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.debtAmount =
            object.debtAmount !== undefined && object.debtAmount !== null
                ? String(object.debtAmount)
                : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromString(object.id)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.liquidator !== undefined && (obj.liquidator = message.liquidator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.collateralDenom !== undefined &&
            (obj.collateralDenom = message.collateralDenom);
        message.collateralAmountLiquidated !== undefined &&
            (obj.collateralAmountLiquidated = message.collateralAmountLiquidated);
        message.collateralAmountLiquidator !== undefined &&
            (obj.collateralAmountLiquidator = message.collateralAmountLiquidator);
        message.collateralAmountFee !== undefined &&
            (obj.collateralAmountFee = message.collateralAmountFee);
        message.liquidationPrice !== undefined &&
            (obj.liquidationPrice = message.liquidationPrice);
        message.marketPrice !== undefined &&
            (obj.marketPrice = message.marketPrice);
        message.discount !== undefined && (obj.discount = message.discount);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.debtAmount !== undefined && (obj.debtAmount = message.debtAmount);
        message.id !== undefined &&
            (obj.id = (message.id || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const message = Object.assign({}, baseLiquidateCollateralEvent);
        message.liquidator = (_a = object.liquidator) !== null && _a !== void 0 ? _a : "";
        message.debtor = (_b = object.debtor) !== null && _b !== void 0 ? _b : "";
        message.collateralDenom = (_c = object.collateralDenom) !== null && _c !== void 0 ? _c : "";
        message.collateralAmountLiquidated =
            (_d = object.collateralAmountLiquidated) !== null && _d !== void 0 ? _d : "";
        message.collateralAmountLiquidator =
            (_e = object.collateralAmountLiquidator) !== null && _e !== void 0 ? _e : "";
        message.collateralAmountFee = (_f = object.collateralAmountFee) !== null && _f !== void 0 ? _f : "";
        message.liquidationPrice = (_g = object.liquidationPrice) !== null && _g !== void 0 ? _g : "";
        message.marketPrice = (_h = object.marketPrice) !== null && _h !== void 0 ? _h : "";
        message.discount = (_j = object.discount) !== null && _j !== void 0 ? _j : "";
        message.debtDenom = (_k = object.debtDenom) !== null && _k !== void 0 ? _k : "";
        message.debtAmount = (_l = object.debtAmount) !== null && _l !== void 0 ? _l : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromValue(object.id)
                : long_1.default.UZERO;
        return message;
    },
};
const baseLiquidateCollateralWithStablecoinEvent = {
    creator: "",
    liquidator: "",
    debtor: "",
    collateralDenom: "",
    collateralAmountLiquidated: "",
    collateralAmountLiquidator: "",
    collateralAmountFee: "",
    liquidationPrice: "",
    marketPrice: "",
    discount: "",
    debtDenom: "",
    debtAmount: "",
    principalAmount: "",
    interestDenom: "",
    interestAmount: "",
    id: long_1.default.UZERO,
};
exports.LiquidateCollateralWithStablecoinEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.liquidator !== "") {
            writer.uint32(18).string(message.liquidator);
        }
        if (message.debtor !== "") {
            writer.uint32(26).string(message.debtor);
        }
        if (message.collateralDenom !== "") {
            writer.uint32(34).string(message.collateralDenom);
        }
        if (message.collateralAmountLiquidated !== "") {
            writer.uint32(42).string(message.collateralAmountLiquidated);
        }
        if (message.collateralAmountLiquidator !== "") {
            writer.uint32(50).string(message.collateralAmountLiquidator);
        }
        if (message.collateralAmountFee !== "") {
            writer.uint32(58).string(message.collateralAmountFee);
        }
        if (message.liquidationPrice !== "") {
            writer.uint32(66).string(message.liquidationPrice);
        }
        if (message.marketPrice !== "") {
            writer.uint32(74).string(message.marketPrice);
        }
        if (message.discount !== "") {
            writer.uint32(82).string(message.discount);
        }
        if (message.debtDenom !== "") {
            writer.uint32(90).string(message.debtDenom);
        }
        if (message.debtAmount !== "") {
            writer.uint32(98).string(message.debtAmount);
        }
        if (message.principalAmount !== "") {
            writer.uint32(106).string(message.principalAmount);
        }
        if (message.interestDenom !== "") {
            writer.uint32(114).string(message.interestDenom);
        }
        if (message.interestAmount !== "") {
            writer.uint32(122).string(message.interestAmount);
        }
        if (!message.id.isZero()) {
            writer.uint32(128).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseLiquidateCollateralWithStablecoinEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.liquidator = reader.string();
                    break;
                case 3:
                    message.debtor = reader.string();
                    break;
                case 4:
                    message.collateralDenom = reader.string();
                    break;
                case 5:
                    message.collateralAmountLiquidated = reader.string();
                    break;
                case 6:
                    message.collateralAmountLiquidator = reader.string();
                    break;
                case 7:
                    message.collateralAmountFee = reader.string();
                    break;
                case 8:
                    message.liquidationPrice = reader.string();
                    break;
                case 9:
                    message.marketPrice = reader.string();
                    break;
                case 10:
                    message.discount = reader.string();
                    break;
                case 11:
                    message.debtDenom = reader.string();
                    break;
                case 12:
                    message.debtAmount = reader.string();
                    break;
                case 13:
                    message.principalAmount = reader.string();
                    break;
                case 14:
                    message.interestDenom = reader.string();
                    break;
                case 15:
                    message.interestAmount = reader.string();
                    break;
                case 16:
                    message.id = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseLiquidateCollateralWithStablecoinEvent);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.liquidator =
            object.liquidator !== undefined && object.liquidator !== null
                ? String(object.liquidator)
                : "";
        message.debtor =
            object.debtor !== undefined && object.debtor !== null
                ? String(object.debtor)
                : "";
        message.collateralDenom =
            object.collateralDenom !== undefined && object.collateralDenom !== null
                ? String(object.collateralDenom)
                : "";
        message.collateralAmountLiquidated =
            object.collateralAmountLiquidated !== undefined &&
                object.collateralAmountLiquidated !== null
                ? String(object.collateralAmountLiquidated)
                : "";
        message.collateralAmountLiquidator =
            object.collateralAmountLiquidator !== undefined &&
                object.collateralAmountLiquidator !== null
                ? String(object.collateralAmountLiquidator)
                : "";
        message.collateralAmountFee =
            object.collateralAmountFee !== undefined &&
                object.collateralAmountFee !== null
                ? String(object.collateralAmountFee)
                : "";
        message.liquidationPrice =
            object.liquidationPrice !== undefined && object.liquidationPrice !== null
                ? String(object.liquidationPrice)
                : "";
        message.marketPrice =
            object.marketPrice !== undefined && object.marketPrice !== null
                ? String(object.marketPrice)
                : "";
        message.discount =
            object.discount !== undefined && object.discount !== null
                ? String(object.discount)
                : "";
        message.debtDenom =
            object.debtDenom !== undefined && object.debtDenom !== null
                ? String(object.debtDenom)
                : "";
        message.debtAmount =
            object.debtAmount !== undefined && object.debtAmount !== null
                ? String(object.debtAmount)
                : "";
        message.principalAmount =
            object.principalAmount !== undefined && object.principalAmount !== null
                ? String(object.principalAmount)
                : "";
        message.interestDenom =
            object.interestDenom !== undefined && object.interestDenom !== null
                ? String(object.interestDenom)
                : "";
        message.interestAmount =
            object.interestAmount !== undefined && object.interestAmount !== null
                ? String(object.interestAmount)
                : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromString(object.id)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.liquidator !== undefined && (obj.liquidator = message.liquidator);
        message.debtor !== undefined && (obj.debtor = message.debtor);
        message.collateralDenom !== undefined &&
            (obj.collateralDenom = message.collateralDenom);
        message.collateralAmountLiquidated !== undefined &&
            (obj.collateralAmountLiquidated = message.collateralAmountLiquidated);
        message.collateralAmountLiquidator !== undefined &&
            (obj.collateralAmountLiquidator = message.collateralAmountLiquidator);
        message.collateralAmountFee !== undefined &&
            (obj.collateralAmountFee = message.collateralAmountFee);
        message.liquidationPrice !== undefined &&
            (obj.liquidationPrice = message.liquidationPrice);
        message.marketPrice !== undefined &&
            (obj.marketPrice = message.marketPrice);
        message.discount !== undefined && (obj.discount = message.discount);
        message.debtDenom !== undefined && (obj.debtDenom = message.debtDenom);
        message.debtAmount !== undefined && (obj.debtAmount = message.debtAmount);
        message.principalAmount !== undefined &&
            (obj.principalAmount = message.principalAmount);
        message.interestDenom !== undefined &&
            (obj.interestDenom = message.interestDenom);
        message.interestAmount !== undefined &&
            (obj.interestAmount = message.interestAmount);
        message.id !== undefined &&
            (obj.id = (message.id || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const message = Object.assign({}, baseLiquidateCollateralWithStablecoinEvent);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.liquidator = (_b = object.liquidator) !== null && _b !== void 0 ? _b : "";
        message.debtor = (_c = object.debtor) !== null && _c !== void 0 ? _c : "";
        message.collateralDenom = (_d = object.collateralDenom) !== null && _d !== void 0 ? _d : "";
        message.collateralAmountLiquidated =
            (_e = object.collateralAmountLiquidated) !== null && _e !== void 0 ? _e : "";
        message.collateralAmountLiquidator =
            (_f = object.collateralAmountLiquidator) !== null && _f !== void 0 ? _f : "";
        message.collateralAmountFee = (_g = object.collateralAmountFee) !== null && _g !== void 0 ? _g : "";
        message.liquidationPrice = (_h = object.liquidationPrice) !== null && _h !== void 0 ? _h : "";
        message.marketPrice = (_j = object.marketPrice) !== null && _j !== void 0 ? _j : "";
        message.discount = (_k = object.discount) !== null && _k !== void 0 ? _k : "";
        message.debtDenom = (_l = object.debtDenom) !== null && _l !== void 0 ? _l : "";
        message.debtAmount = (_m = object.debtAmount) !== null && _m !== void 0 ? _m : "";
        message.principalAmount = (_o = object.principalAmount) !== null && _o !== void 0 ? _o : "";
        message.interestDenom = (_p = object.interestDenom) !== null && _p !== void 0 ? _p : "";
        message.interestAmount = (_q = object.interestAmount) !== null && _q !== void 0 ? _q : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromValue(object.id)
                : long_1.default.UZERO;
        return message;
    },
};
const baseClaimRewardEvent = {
    receiver: "",
    rewardSchemeId: "",
    rewardClaimed: "",
};
exports.ClaimRewardEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.receiver !== "") {
            writer.uint32(10).string(message.receiver);
        }
        if (message.rewardSchemeId !== "") {
            writer.uint32(18).string(message.rewardSchemeId);
        }
        if (message.rewardClaimed !== "") {
            writer.uint32(26).string(message.rewardClaimed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseClaimRewardEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.receiver = reader.string();
                    break;
                case 2:
                    message.rewardSchemeId = reader.string();
                    break;
                case 3:
                    message.rewardClaimed = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseClaimRewardEvent);
        message.receiver =
            object.receiver !== undefined && object.receiver !== null
                ? String(object.receiver)
                : "";
        message.rewardSchemeId =
            object.rewardSchemeId !== undefined && object.rewardSchemeId !== null
                ? String(object.rewardSchemeId)
                : "";
        message.rewardClaimed =
            object.rewardClaimed !== undefined && object.rewardClaimed !== null
                ? String(object.rewardClaimed)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.rewardSchemeId !== undefined &&
            (obj.rewardSchemeId = message.rewardSchemeId);
        message.rewardClaimed !== undefined &&
            (obj.rewardClaimed = message.rewardClaimed);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseClaimRewardEvent);
        message.receiver = (_a = object.receiver) !== null && _a !== void 0 ? _a : "";
        message.rewardSchemeId = (_b = object.rewardSchemeId) !== null && _b !== void 0 ? _b : "";
        message.rewardClaimed = (_c = object.rewardClaimed) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseRewardDebtEvent = { type: "" };
exports.RewardDebtEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rewardDebt !== undefined) {
            reward_scheme_1.RewardDebt.encode(message.rewardDebt, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRewardDebtEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardDebt = reward_scheme_1.RewardDebt.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRewardDebtEvent);
        message.rewardDebt =
            object.rewardDebt !== undefined && object.rewardDebt !== null
                ? reward_scheme_1.RewardDebt.fromJSON(object.rewardDebt)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rewardDebt !== undefined &&
            (obj.rewardDebt = message.rewardDebt
                ? reward_scheme_1.RewardDebt.toJSON(message.rewardDebt)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRewardDebtEvent);
        message.rewardDebt =
            object.rewardDebt !== undefined && object.rewardDebt !== null
                ? reward_scheme_1.RewardDebt.fromPartial(object.rewardDebt)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseRewardSchemeEvent = { type: "" };
exports.RewardSchemeEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rewardScheme !== undefined) {
            reward_scheme_1.RewardScheme.encode(message.rewardScheme, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRewardSchemeEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardScheme = reward_scheme_1.RewardScheme.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRewardSchemeEvent);
        message.rewardScheme =
            object.rewardScheme !== undefined && object.rewardScheme !== null
                ? reward_scheme_1.RewardScheme.fromJSON(object.rewardScheme)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rewardScheme !== undefined &&
            (obj.rewardScheme = message.rewardScheme
                ? reward_scheme_1.RewardScheme.toJSON(message.rewardScheme)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRewardSchemeEvent);
        message.rewardScheme =
            object.rewardScheme !== undefined && object.rewardScheme !== null
                ? reward_scheme_1.RewardScheme.fromPartial(object.rewardScheme)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseAddReserveEvent = { amountAdded: "" };
exports.AddReserveEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rewardScheme !== undefined) {
            reward_scheme_1.RewardScheme.encode(message.rewardScheme, writer.uint32(10).fork()).ldelim();
        }
        if (message.amountAdded !== "") {
            writer.uint32(18).string(message.amountAdded);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAddReserveEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardScheme = reward_scheme_1.RewardScheme.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.amountAdded = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseAddReserveEvent);
        message.rewardScheme =
            object.rewardScheme !== undefined && object.rewardScheme !== null
                ? reward_scheme_1.RewardScheme.fromJSON(object.rewardScheme)
                : undefined;
        message.amountAdded =
            object.amountAdded !== undefined && object.amountAdded !== null
                ? String(object.amountAdded)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rewardScheme !== undefined &&
            (obj.rewardScheme = message.rewardScheme
                ? reward_scheme_1.RewardScheme.toJSON(message.rewardScheme)
                : undefined);
        message.amountAdded !== undefined &&
            (obj.amountAdded = message.amountAdded);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseAddReserveEvent);
        message.rewardScheme =
            object.rewardScheme !== undefined && object.rewardScheme !== null
                ? reward_scheme_1.RewardScheme.fromPartial(object.rewardScheme)
                : undefined;
        message.amountAdded = (_a = object.amountAdded) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseRefundReserveEvent = { amountRefunded: "" };
exports.RefundReserveEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rewardScheme !== undefined) {
            reward_scheme_1.RewardScheme.encode(message.rewardScheme, writer.uint32(10).fork()).ldelim();
        }
        if (message.amountRefunded !== "") {
            writer.uint32(18).string(message.amountRefunded);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRefundReserveEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardScheme = reward_scheme_1.RewardScheme.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.amountRefunded = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRefundReserveEvent);
        message.rewardScheme =
            object.rewardScheme !== undefined && object.rewardScheme !== null
                ? reward_scheme_1.RewardScheme.fromJSON(object.rewardScheme)
                : undefined;
        message.amountRefunded =
            object.amountRefunded !== undefined && object.amountRefunded !== null
                ? String(object.amountRefunded)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rewardScheme !== undefined &&
            (obj.rewardScheme = message.rewardScheme
                ? reward_scheme_1.RewardScheme.toJSON(message.rewardScheme)
                : undefined);
        message.amountRefunded !== undefined &&
            (obj.amountRefunded = message.amountRefunded);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRefundReserveEvent);
        message.rewardScheme =
            object.rewardScheme !== undefined && object.rewardScheme !== null
                ? reward_scheme_1.RewardScheme.fromPartial(object.rewardScheme)
                : undefined;
        message.amountRefunded = (_a = object.amountRefunded) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
